import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { UploadInput } from 'ngx-uploader';
import { Globals } from '../helpers';
import { Application } from '../models/application.model';
import { HttpInterceptor } from './http-error.interceptor';

@Injectable()
export class ApplicationService {
  private serviceUrl: string;

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.serviceUrl = globals.url + 'applications/';
  }

  public getById(appId: string) {
    return this.http
      .get(this.serviceUrl + appId)
      .map((response: Response) => response.json());
  }
  public create(app) {
    return this.http
      .post(this.serviceUrl, app)
      .map((response: Response) => response.json());
  }

  public getAll(page?, limit?, filters?) {
    let url = this.serviceUrl;
    if (typeof page !== 'undefined' && typeof limit !== 'undefined') {
      url += '?page=' + page + '&limit=' + limit;
    } else {
      url += '?page=0';
    }
    if (typeof filters !== 'undefined') {
      Object.keys(filters).forEach((filter) => {
        url += '&' + filter + '=' + filters[filter];
      });
    }
    return this.http.get(url).map((response: Response) => response.json());
  }

  public putThumbnail(id: string) {
    const event: UploadInput = {
      method: 'PUT',
      url: this.serviceUrl + id + '/thumbnail',
      type: 'uploadAll',
      headers: this.http.jwt(),
    };
    return event;
  }

  public deleteThumbnail(id: string) {
    return this.http
      .delete(this.serviceUrl + id + '/thumbnail')
      .map((response: Response) => response.json());
  }

  public update(appId: string, app: Application) {
    return this.http
      .put(this.serviceUrl + appId, app)
      .map((response: Response) => response.json());
  }
  public delete(appId: string) {
    return this.http
      .delete(this.serviceUrl + appId)
      .map((response: Response) => response.json());
  }

  public getContentNodes(appId: string) {
    return this.http
      .get(this.serviceUrl + appId + '/nodes')
      .map((response: Response) => response.json());
  }

  public subscribeDevicesToApp(appId: string, deviceIds: string[]) {
    const subscribeDeviceIds = { subscribeDeviceIds: deviceIds };
    return this.http
      .put(this.serviceUrl + appId + '/subscribe', subscribeDeviceIds)
      .map((response: Response) => response.json());
  }
  public unsubscribeDevicesFromApp(appId: string, deviceIds: string[]) {
    const unsubscribeDeviceIds = { unsubscribeDeviceIds: deviceIds };
    return this.http
      .put(this.serviceUrl + appId + '/unsubscribe', unsubscribeDeviceIds)
      .map((response: Response) => response.json());
  }

  public getSubscribedDevices(appId: string, page?, limit?, filters?) {
    let url = this.serviceUrl + appId + '/subscribedDevices';
    if (typeof page == 'number' && typeof limit == 'number') {
      url = this.prepareUrlFilters(url, { ...filters, page, limit });
    } else {
      url = this.prepareUrlFilters(url, filters);
    }
    return this.http.get(url).map((response: Response) => response.json());
  }
  public getDevicesToSubscribe(appId: string, page?, limit?, filters?) {
    let url = this.serviceUrl + appId + '/notSubscribedDevices';
    if (typeof page == 'number' && typeof limit == 'number') {
      url = this.prepareUrlFilters(url, { ...filters, page, limit });
    } else {
      url = this.prepareUrlFilters(url, filters);
    }
    return this.http.get(url).map((response: Response) => response.json());
  }
  public enterMaintainenceMode(appId: string) {
    return this.http
      .put(this.serviceUrl + appId + '/maintenance', null)
      .map((response: Response) => response.json());
  }

  public leaveMaintainenceMode(appId: string) {
    return this.http
      .delete(this.serviceUrl + appId + '/maintenance')
      .map((response: Response) => response.json());
  }
  public uploadFile(appId: string) {
    const event: UploadInput = {
      url: this.serviceUrl + appId + '/upload',
      method: 'POST',
      type: 'uploadAll',
      headers: this.http.jwt(),
    };
    return event;
  }
  private prepareUrlFilters(url, filters) {
    const params: URLSearchParams = new URLSearchParams();
    if (!filters || !Object.keys(filters).length) { return url; }
    Object.entries(filters).forEach(([key, value]) => {
      params.append(key, value.toString());
    });
    const paramsStr = params.toString();
    if (paramsStr) { url += '?' + paramsStr; }
    return url;
  }
}
